<!-- Answers: how do my locations compare, and lets you filter the dashboard on one. -->
<template>
    <dashboard-panel title="Locations" :subtitle="subtitle">
        <div v-if="rows.length" class="tabel-wikkel">
            <table class="tabel">
                <thead>
                    <tr>
                        <th>Location</th>
                        <th class="rechts">Cubes</th>
                        <th class="rechts">Bookings</th>
                        <th class="rechts">Players</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="row in rows"
                        :key="row.id"
                        class="klikbaar"
                        tabindex="0"
                        @click="$emit('select', row.id)"
                        @keydown.enter="$emit('select', row.id)"
                    >
                        <td>
                            <div class="twee afkap">
                                <span><span v-if="row.country" :class="flagClass(row.country)"></span>{{ row.name }}</span>
                                <small>{{ (row.country || "").toUpperCase() }}</small>
                            </div>
                        </td>
                        <td class="num rechts">{{ row.cubes }}</td>
                        <td class="num rechts">{{ formatInt(row.bookings) }}</td>
                        <td class="num rechts">{{ formatInt(row.players) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="locaties-leeg">No bookings match these filters. Clear a filter to compare locations.</p>
    </dashboard-panel>
</template>

<script setup>
import DashboardPanel from "./DashboardPanel.vue";

defineProps({
    rows: { type: Array, default: () => [] },
    subtitle: { type: String, default: "Click a location to filter the whole dashboard on it." },
});

defineEmits(["select"]);

function formatInt(value) {
    return Number(value || 0).toLocaleString();
}

function flagClass(country) {
    return country ? `vlag fi fi-${country.toLowerCase()}` : "";
}
</script>

<style scoped lang="scss">
.locaties-leeg {
    margin: 0;
    color: var(--muted);
    font-size: 14px;
}
</style>
